/* global angular, $ */
// Create templates module for ngTemplates to attach to
angular.module('ua5Templates', []);
// start module declaration
angular.module('ua5App.home', []);
angular.module('ua5App.about', []);
angular.module('ua5App.participants', []);
angular.module('ua5App.participant', []);
angular.module('ua5App.index', []);
// end module declaration
// Create parent module for application
angular.module('ua5App', [
    'ngResource',
    'ngSanitize',
    'ngTouch',
    'ngAnimate',
    'ua5Templates',
    'ui.router',
    'angulartics',
    'angulartics.google.analytics',
    'angular-loading-bar',
    'angularModalService',
    'ngMeta',
    // start add states as app dependency
    'ua5App.participant',
    'ua5App.participants',
    'ua5App.about',
    'ua5App.home',
    'ua5App.index'
    // end add states as app dependency
])
    .constant('BREAKPOINTS', {
        MOBILE: 375,
        PHABLET: 767,
        TABLET: 991,
        LAPTOP: 1199,
        DESKTOP: 1430
    })
    .config(['$analyticsProvider', '$locationProvider', 'ngMetaProvider', function($analyticsProvider, $locationProvider, ngMetaProvider) {
        $locationProvider.html5Mode(true);
        // Prevents bounce rate of 0.01
        $analyticsProvider.withAutoBase(true);
        $analyticsProvider.firstPageview(false);
        ngMetaProvider.setDefaultTitle('An Imaginative Offer | UCLA School of the Arts and Architecture');
        ngMetaProvider.setDefaultTag('url', 'https://www.ucla.arts.edu/an-imaginative-offer');
        ngMetaProvider.setDefaultTag('description', 'Through the unique voices of the UCLA Arts community, An Imaginative Offer celebrates the essential role of the arts in society. We believe that the arts are fundamental to the cognitive, critical, inquisitive life of a public research university, and that the practice and presence of the arts are a cornerstone of the creative, innovative thinking and collaborative spirit that the 21st century demands.');
        ngMetaProvider.setDefaultTag('image', 'https://www.ucla.arts.edu/an-imaginative-offer/assets/img/share.jpg');
    }])
    .run(['ngMeta', function(ngMeta) {
        ngMeta.init();
    }])
    .directive('app', ['$rootScope', function($rootScope) {
        return {
            link: function($scope, $element, $attrs) {
                var $$window;
                $$window = $(window);
                $$window.on('resize', function() {
                    $rootScope.$broadcast('app:resized');
                });
                $$window.on('click', function(e) {
                    $rootScope.$broadcast('app:clicked', e.target);
                });
                $$window.on('scroll', function(e) {
                    $rootScope.$broadcast('app:scrolled');
                });
                $$window.on('keydown', function(e) {
                    var ESCAPE = 27;
                    var keyCode;
                    keyCode = e.keyCode;
                    // Escape key
                    if (keyCode === ESCAPE) {
                        $rootScope.$broadcast('app:escape:pressed');
                    }
                });
                $rootScope.$on('$stateChangeSuccess', function(e, toState, toStateParams, fromState) {
                    var regex = /^([^.]*).*/;
                    var toStateName = toState.name;
                    var fromStateName = fromState.name;
                    var toStateParent = toStateName.match(regex)[1];
                    $rootScope.pageClass = 'page-' + toState.name.replace('.', '-');

                    // Support for multiple index backgrounds
                    if (toStateParams && toStateParams.v) {
                        $rootScope.pageClass += ' index-' + toStateParams.v;
                    }
                    // If going directly to child from non-parent, just show
                    // child.
                    if (fromStateName !== toStateParent) {
                        $('[ui-view] [ui-view]').css({
                            opacity: 1,
                            position: 'static'
                        });
                    }
                    // Lock background if on overlay state
                    if (toStateName === 'participants.participant') {
                        $('body, html').css('overflow', 'hidden');
                    } else {
                        $('body, html').css('overflow', '');
                    }
                });
            }
        };
    }])
;

/* global angular, TweenMax, Quint */
angular.module('ua5App')
    // Fade out old state then fade in the new state
    .animation('.fade-child', [function() {
        var FADE_SPEED = 1;
        return {
            enter: function(element, doneFn) {
                TweenMax.to(element, FADE_SPEED, {
                    alpha: 1,
                    onComplete: function() {
                        TweenMax.set(element, {
                            position: 'static'
                        });
                        doneFn();
                    },
                    ease: Quint.easeInOut
                });
            },
            leave: function(element, doneFn) {
                TweenMax.to(element, FADE_SPEED, {
                    alpha: 0,
                    onComplete: doneFn,
                    ease: Quint.easeInOut
                });
            }
        };
    }])
;

/* global angular, TweenMax, Quint */
angular.module('ua5App')
    // Fade out old state then fade in the new state
    .animation('.fade', [function() {
        var FADE_SPEED = 0.5;
        return {
            enter: function(element, doneFn) {
                TweenMax.to(element, FADE_SPEED, {
                    delay: FADE_SPEED,
                    alpha: 1,
                    onComplete: function() {
                        TweenMax.set(element, {
                            position: 'static'
                        });
                        doneFn();
                    },
                    ease: Quint.easeInOut
                });
            },
            leave: function(element, doneFn) {
                TweenMax.to(element, FADE_SPEED, {
                    alpha: 0,
                    onComplete: function() {
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                        doneFn();
                    },
                    ease: Quint.easeInOut
                });
            }
        };
    }])
;

/* global angular, TweenMax, $ */
angular.module('ua5App')
    .directive('header',  ['$rootScope', '$stateParams', function($rootScope, $stateParams) {
        return {
            restrict: 'A',
            templateUrl: 'components/header/header.html',
            link: function($scope, element, attrs) {
                var SPEED = 0.5;
                var LINKS = '.header__links';

                function getParams() {
                    setTimeout(function() {
                        $scope.currentParam = (($stateParams && $stateParams.v) ? $stateParams.v : null);
                    }, 100);
                }

                function open() {
                    $('body, html').css('overflow', 'hidden');
                    $scope.open = true;
                    TweenMax.to(LINKS, SPEED, {
                        display: 'block',
                        opacity: 1
                    });
                }
                function close() {
                    $('body, html').css('overflow', '');
                    $scope.open = false;
                    TweenMax.to(LINKS, SPEED, {
                        display: 'none',
                        opacity: 0
                    });
                }
                function loadVideo(index) {
                  $rootScope.$broadcast('app:loadVideo', index);
                }
                $scope.toggleOpen = function() {
                    if ($scope.open) {
                        close();
                    } else {
                        open();
                    }
                };
                $scope.$on('$stateChangeStart', close);
                $scope.$on('$stateChangeStart', getParams);
                getParams();
            }
        };
    }])
;

/* global angular, $, Draggable, TweenMax, Power1 */
angular.module('ua5App')
    .directive('indexCarousel', ['$sce', '$rootScope', '$q', '$timeout', function($sce, $rootScope, $q, $timeout) {
        return {
            restrict: 'A',
            scope: {
                indexVideos: '='
            },
            templateUrl: 'components/index-carousel/index-carousel.html',
            link: function($scope, element, attrs) {
                var videoLength,
                    winRatio,
                    thumbWidth = 350,
                    scrollTime = 0.3,
                    scrollDistance = 200;

                $scope.videos = $scope.indexVideos;
                $scope.isLoaded = false;

                $scope.jumpToPoint = function($event) {
                    var center,
                        viewPos,
                        viewRatio;

                    if ($(window).width() > 1140) {
                        center = ($event.clientX - (($(window).width() - 1140) / 2)) - ($('.index-carousel-slider__viewport').width() / 2);
                    } else {
                        center = $event.clientX - (($(window).width() * 0.1) + ($('.index-carousel-slider__viewport').width()) / 2);
                    }

                    TweenMax.set($('.index-carousel-slider__viewport'), {x: center, y: 0});

                    viewPos = $('.index-carousel-slider__viewport').position().left;
                    viewRatio = (viewPos / $('.index-carousel-slider__thumbs').width()) * (-videoLength * thumbWidth);

                    TweenMax.set($('.index-carousel__thumbs'), {x: viewRatio, y: 0});
                };

                function init() {
                    videoLength = $scope.videos.length;
                    winRatio = ($(window).width()) / (videoLength * thumbWidth);

                    $('.index-carousel__thumbs, .index-carousel-main__inner').css('width', videoLength * thumbWidth + 'px');

                    $(window).on('resize', function() {
                        winRatio = $(window).width() / (videoLength * thumbWidth);
                        $('.index-carousel-slider__viewport').css('width', (winRatio * 100) + '%');
                    }).resize();

                    $(window).on('mousewheel DOMMouseScroll', function(e) {
                        var delta = e.originalEvent.wheelDelta / 120 || -e.originalEvent.detail / 3;
                        var mainViewPos = $('.index-carousel__thumbs').position().left;
                        var finalScroll = mainViewPos + parseInt(delta * scrollDistance, 10);
                        var viewRatio = -((finalScroll / $('.index-carousel__thumbs').width()) * $('.index-carousel-slider__thumbs').width());

                        e.preventDefault();

                        if ($(window).width() < 1140) {
                            if (finalScroll > 0) {
                                finalScroll = 0;
                            } else if (finalScroll < -(videoLength * thumbWidth) + $(window).width()) {
                                finalScroll = -(videoLength * thumbWidth) + $(window).width();
                            }
                        } else {
                            if (finalScroll > 0) {
                                finalScroll = 0;
                            } else if (finalScroll < -(videoLength * thumbWidth) + 1140) {
                                finalScroll = -(videoLength * thumbWidth) + 1140;
                            }
                        }

                        if (viewRatio < 0) {
                            viewRatio = 0;
                        } else if (viewRatio > $('.index-carousel-slider__thumbs').width() - $('.index-carousel-slider__viewport').width()) {
                            viewRatio = $('.index-carousel-slider__thumbs').width() - $('.index-carousel-slider__viewport').width();
                        }

                        if (mainViewPos <= 0 && mainViewPos > -(videoLength * thumbWidth)) {
                            TweenMax.to($('.index-carousel__thumbs'), scrollTime, {
                                x: finalScroll,
                                ease: Power1.easeOut
                            });

                            TweenMax.to($('.index-carousel-slider__viewport'), scrollTime, {
                                x: viewRatio,
                                ease: Power1.easeOut
                            });
                        }
                    });

                    Draggable.create($('.index-carousel-slider__viewport'), {
                        type: 'x',
                        bounds: '.index-carousel-slider',
                        onDrag: function(data) {
                            var viewPos = $('.index-carousel-slider__viewport').position().left < $('.index-carousel-slider__thumbs').width() / 2 ? $('.index-carousel-slider__viewport').position().left : $('.index-carousel-slider__viewport').position().left + ($('.index-carousel-slider__viewport').width() / 5);
                            var viewRatio = (viewPos / $('.index-carousel-slider__thumbs').width()) * (-videoLength * thumbWidth);
                            TweenMax.set($('.index-carousel__thumbs'), {x: viewRatio, y: 0});
                        }
                    });

                    Draggable.create($('.index-carousel__thumbs'), {
                        type: 'x',
                        bounds: '.index-carousel-main',
                        onDrag: function() {
                            var viewPos = $('.index-carousel__thumbs').position().left;
                            var viewRatio = -((viewPos / $('.index-carousel__thumbs').width()) * $('.index-carousel-slider__thumbs').width());
                            TweenMax.set($('.index-carousel-slider__viewport'), {x: viewRatio, y: 0});
                        }
                    });

                    if (!$scope.isLoaded) {
                        setTimeout(function() {
                            $scope.isLoaded = true;
                            $scope.$apply();
                        }, 1200);
                    }
                }

                $scope.$on('$destroy', function() {
                    $scope.isLoaded = false;
                    $(window).off('mousewheel DOMMouseScroll');
                    $(window).off('resize');
                });

                init();
            }
        };
    }])
;

/* global angular, ScrollReveal */
angular.module('ua5App')
    .directive('scrollReveal', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            scope: {
                scrollRevealSettings: '='
            },
            link: function($scope, element, attrs) {
                $timeout(function() {
                    if (!window.scrollReveal) {
                        window.scrollReveal = new ScrollReveal();
                    }
                    window.scrollReveal.reveal(element, $scope.scrollRevealSettings);
                }, 0);
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .directive('shareE', ['$location', function($location) {
        return {
            restrict: 'A',
            scope: {
                shareEBody: '@',
                shareESubject: '@'
            },
            link: function($scope, element, attrs) {
                var body;
                var subject;
                body = $scope.shareEBody || $location.absUrl();
                subject = $scope.shareESubject || $location.absUrl();
                element[0].href = 'mailto:?subject=' + subject + '&body=' + body;
                element[0].target = '_blank';
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .directive('shareFb', ['popup', '$location', function(popup, $location) {
        return {
            restrict: 'A',
            scope: {
                shareFbUrl: '@'
            },
            link: function($scope, element, attrs) {
                var url;
                var fbUrl;
                url = $scope.shareFbUrl || $location.absUrl();
                fbUrl = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(url);
                element.on('click', function() {
                    popup.show(fbUrl);
                });
                $scope.$on('$destroy', function() {
                    element.off('click');
                });
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .directive('shareTw', ['popup', '$location', function(popup, $location) {
        return {
            restrict: 'A',
            scope: {
                shareTwUrl: '@',
                shareTwText: '@'
            },
            link: function($scope, element, attrs) {
                var text;
                var twUrl;
                var url;
                url = $scope.shareTwUrl || $location.absUrl();
                text = $scope.shareTwText || '';
                twUrl = 'https://twitter.com/intent/tweet?text=' + text + '&url=' + url;
                element.on('click', function() {
                    popup.show(twUrl, 600, 253);
                });
                $scope.$on('$destroy', function() {
                    element.off('click');
                });
            }
        };
    }])
;

/* global angular, _, $ */
angular.module('ua5App')
    .directive('unorphanize', [function() {
        return {
            restrict: 'A',
            scope: {
                unorphanize: '@'
            },
            link: function($scope, element, attrs) {
                var n;
                n = parseInt($scope.unorphanize, 10) || 1;
                _.defer(function() {
                    $(element).unorphanize(n);
                });
            }
        };
    }])
;

/* global angular, $, TweenMax, _, Draggable */
angular.module('ua5App')
    .directive('vcarousel', ['$sce', '$rootScope', '$q', '$timeout', '$stateParams', '$location', function($sce, $rootScope, $q, $timeout, $stateParams, $location) {
        return {
            restrict: 'A',
            scope: {
                vcarouselVideos: '='
            },
            templateUrl: 'components/vcarousel/vcarousel.html',
            link: function($scope, element) {
                var mmt;
                var slug;
                var video;
                var thumbsWidth;
                slug = $stateParams.v;
                $scope.videos = $scope.vcarouselVideos;

                // Set width of vcarousel scroll container
                $timeout(function() {
                    thumbsWidth = $('.vcarousel__thumbs').width();
                    $('.vcarousel__thumbs__scroll-container').css('width', thumbsWidth + 15);
                }, 500);

                // Get video element
                video = $(element).find('video')[0];

                // Get current video based on slug
                $scope.currentVideo = _.findWhere($scope.videos, {slug: slug});

                // Default to first video if video is not explicitly set
                if (!$scope.currentVideo) {
                    $scope.currentVideo = $scope.videos[0];
                    $scope.source = $scope.currentVideo.videoMp4;

                    // Reset search query
                    $location.search('v', null);
                } else {
                    // If there is a currentVideo, use that
                    $scope.source = $scope.currentVideo.videoMp4;
                }

                // Fade video in, change query param and play video
                function play() {
                    $rootScope.playing = true;
                    $scope.$applyAsync();
                    video.play().then(function() {
                        // Fade in video
                        TweenMax.to('.vcarousel__video-wrap', 2, {
                            opacity: 1
                        });
                    });

                }

                // Pause video
                function pause() {
                    $rootScope.playing = false;
                    video.pause();
                }

                // Toggle video playing state
                $scope.togglePlay = function() {
                    if (!$rootScope.playing) {
                        play();
                    } else {
                        pause();
                    }
                };

                // Swap the src of the video element and play
                $scope.updateCurrentVideo = function(v) {
                    pause();

                    // As long as its a different video, let's fade out the currently playing video and then
                    // fade in the new one
                    if (v !== $scope.currentVideo) {
                        TweenMax.to('.vcarousel__video-wrap', 1, {
                            opacity: 0,
                            onComplete: function() {
                                $scope.currentVideo = v;
                                $scope.$apply();
                                video.src = $scope.currentVideo.videoMp4;
                                play();
                            }
                        });
                    }
                };

                // Go to next video if video completes
                video.addEventListener('ended', function() {
                    var currentIndex;
                    var videosLength;
                    var newIndex;
                    videosLength = $scope.videos.length;
                    currentIndex = $scope.videos.indexOf($scope.currentVideo);
                    if (currentIndex + 1 === videosLength) {
                        newIndex = 0;
                    } else {
                        newIndex = currentIndex + 1;
                    }
                    $scope.updateCurrentVideo($scope.videos[newIndex]);
                });

                $scope.mouseMoving = function() {
                    $timeout.cancel(mmt);
                    $rootScope.moving = true;
                    mmt = $timeout(function() {
                        $rootScope.moving = false;
                    }, 1000);
                };

                Draggable.create($('.vcarousel__thumbs'), {
                    type: 'x',
                    bounds: 'body',
                    dragClickables: true,
                    minimumMovement: 10,
                    onDragStart: function() {
                        $('.vcarousel__thumb').css('cursor', 'move');
                    },
                    onRelease: function() {
                        $('.vcarousel__thumb').css('cursor', 'pointer');
                    }
                });

                $scope.$on('$destroy', function() {
                    $rootScope.playing = false;
                    $rootScope.moving = false;
                });
            }
        };
    }])
;

/* global angular */
angular.module('ua5App').
    filter('trust', ['$sce', function($sce) {
        return function(value) {
            return $sce.trustAsResourceUrl(value);
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .factory('about', ['$resource', '$q', function($resource, $q) {
        var d;
        var initialized;
        d = $q.defer();
        return {
            get: function() {
                if (!initialized) {
                    initialized = true;
                    $resource('data/about.json').get(function(data) {
                        d.resolve(data);
                    });
                }
                return d.promise;
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .factory('home', ['$resource', '$q', function($resource, $q) {
        var d;
        var initialized;
        d = $q.defer();
        return {
            get: function() {
                if (!initialized) {
                    initialized = true;
                    $resource('data/home.json').get(function(data) {
                        d.resolve(data);
                    });
                }
                return d.promise;
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .factory('index', ['$resource', '$q', function($resource, $q) {
        var d;
        var initialized;
        d = $q.defer();
        return {
            get: function() {
                if (!initialized) {
                    initialized = true;
                    $resource('data/index.json').get(function(data) {
                        d.resolve(data);
                    });
                }
                return d.promise;
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .factory('participants', ['$resource', '$q', function($resource, $q) {
        var d;
        var initialized;
        d = $q.defer();
        return {
            get: function() {
                if (!initialized) {
                    initialized = true;
                    $resource('data/participants.json').get(function(data) {
                        d.resolve(data);
                    });
                }
                return d.promise;
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .factory('popup', [function() {
        function show(url, width, height) {
            var h;
            var leftPosition;
            var topPosition;
            var w;
            w = width || 600;
            h = height || 600;
            //Allow for borders.
            leftPosition = (window.screen.width / 2) - ((w / 2) + 10);
            //Allow for title and status bars.
            topPosition = (window.screen.height / 2) - ((h / 2) + 50);
            //Open the window.
            window.open(url, 'Window2', 'status=no,height=' + h + ',width=' + w + ',resizable=yes,left=' + leftPosition + ',top=' + topPosition + ',screenX=' + leftPosition + ',screenY=' + topPosition + ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no');
            return false;
        }
        return {
            show: show
        };
    }])
;

/* global angular, $ */
// I provide a utility class for preloading image objects.
angular.module('ua5App').factory('preloader', ['$q', '$rootScope', function($q, $rootScope) {
        // I manage the preloading of image objects. Accepts an array of image URLs.
        function Preloader(imageLocations) {
            // I am the image SRC values to preload.
            this.imageLocations = imageLocations;
            // As the images load, we'll need to keep track of the load/error
            // counts when announing the progress on the loading.
            this.imageCount = this.imageLocations.length;
            this.loadCount = 0;
            this.errorCount = 0;
            // I am the possible states that the preloader can be in.
            this.states = {
                PENDING: 1,
                LOADING: 2,
                RESOLVED: 3,
                REJECTED: 4
            };
            // I keep track of the current state of the preloader.
            this.state = this.states.PENDING;
            // When loading the images, a promise will be returned to indicate
            // when the loading has completed (and / or progressed).
            this.deferred = $q.defer();
            this.promise = this.deferred.promise;
        }
        // ---
        // STATIC METHODS.
        // ---
        // I reload the given images [Array] and return a promise. The promise
        // will be resolved with the array of image locations.
        Preloader.preloadImages = function(imageLocations) {
            var preloader = new Preloader(imageLocations);
            return (preloader.load());
        };
        // ---
        // INSTANCE METHODS.
        // ---
        Preloader.prototype = {
            // Best practice for "instnceof" operator.
            constructor: Preloader,
            // ---
            // PUBLIC METHODS.
            // ---
            // I determine if the preloader has started loading images yet.
            isInitiated: function isInitiated() {
                return (this.state !== this.states.PENDING);
            },
            // I determine if the preloader has failed to load all of the images.
            isRejected: function isRejected() {
                return (this.state === this.states.REJECTED);
            },
            // I determine if the preloader has successfully loaded all of the images.
            isResolved: function isResolved() {
                return (this.state === this.states.RESOLVED);
            },
            // I initiate the preload of the images. Returns a promise.
            load: function load() {
                // If the images are already loading, return the existing promise.
                if (this.isInitiated()) {
                    return (this.promise);
                }
                this.state = this.states.LOADING;
                for (var i = 0 ; i < this.imageCount ; i++) {
                    this.loadImageLocation(this.imageLocations[ i ]);
                }
                // Return the deferred promise for the load event.
                return (this.promise);
            },
            // ---
            // PRIVATE METHODS.
            // ---
            // I handle the load-failure of the given image location.
            handleImageError: function handleImageError(imageLocation) {
                this.errorCount++;
                // If the preload action has already failed, ignore further action.
                if (this.isRejected()) {
                    return;
                }
                this.state = this.states.REJECTED;
                this.deferred.reject(imageLocation);
            },
            // I handle the load-success of the given image location.
            handleImageLoad: function handleImageLoad(imageLocation) {
                this.loadCount++;
                // If the preload action has already failed, ignore further action.
                if (this.isRejected()) {
                    return;
                }
                // Notify the progress of the overall deferred. This is different
                // than Resolving the deferred - you can call notify many times
                // before the ultimate resolution (or rejection) of the deferred.
                this.deferred.notify({
                    percent: Math.ceil(this.loadCount / this.imageCount * 100),
                    imageLocation: imageLocation
                });
                // If all of the images have loaded, we can resolve the deferred
                // value that we returned to the calling context.
                if (this.loadCount === this.imageCount) {
                    this.state = this.states.RESOLVED;
                    this.deferred.resolve(this.imageLocations);
                }
            },
            // I load the given image location and then wire the load / error
            // events back into the preloader instance.
            // --
            // NOTE: The load/error events trigger a $digest.
            loadImageLocation: function loadImageLocation(imageLocation) {
                var self = this;
                // When it comes to creating the image object, it is critical that
                // we bind the event handlers BEFORE we actually set the image
                // source. Failure to do so will prevent the events from proper
                // triggering in some browsers.
                var image = $(new Image())
                    .load(
                        function(event) {
                            // Since the load event is asynchronous, we have to
                            // tell AngularJS that something changed.
                            $rootScope.$apply(
                                function() {
                                    self.handleImageLoad(event.target.src);
                                    // Clean up object reference to help with the
                                    // garbage collection in the closure.
                                    self = image = event = null;
                                }
                           );
                        }
                   )
                    .error(
                        function(event) {
                            // Since the load event is asynchronous, we have to
                            // tell AngularJS that something changed.
                            $rootScope.$apply(
                                function() {
                                    self.handleImageError(event.target.src);
                                    // Clean up object reference to help with the
                                    // garbage collection in the closure.
                                    self = image = event = null;
                                }
                           );
                        }
                   )
                    .prop('src', imageLocation)
                ;
            }
        };
        // Return the factory instance.
        return (Preloader);
    }
]);

/* global angular, $, Modernizr */
angular.module('ua5App.about')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('about', {
            url: '/about',
            templateUrl: 'states/about/about.html',
            controller: 'aboutCtrl',
            controllerAs: 'ctrl',
            resolve: {
                data: ['about', function(about) {
                    return about.get().then(function(data) {
                        return data;
                    });
                }]
            },
            meta: {
                title: 'About | An Imaginative Offer',
                url: 'https://ucla.arts.edu/an-imaginative-offer/about'
            }
        });
    }])
    .controller('aboutCtrl', ['data', '$scope', function(data, $scope) {
        var video = $('.about__video__video');
        var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
        $scope.data = data;
        $scope.source = isFirefox ? $scope.data.video.srcWebm : $scope.data.video.srcMp4;
        $scope.type = isFirefox ? 'video/webm' : 'video/mp4';
        $scope.hideControls = false;
        $scope.hideArrow = false;

        $(window).off('mousewheel DOMMouseScroll');
        $(window).off('resize');

        $scope.hoverIn = function() {
            console.log('called');
            console.log(video.attr('controls'));
            video.attr('controls', 'controls');
            $scope.hideControls = true;
        };

        $scope.hoverOut = function() {
            if (!video[0].paused) {
                video.attr('controls', 'controls');
                $scope.hideControls = true;
            } else {
                video.removeAttr('controls');
                $scope.hideControls = false;
            }
        };

        $scope.playVideoMobile = function() {
            if (Modernizr.touch) {
                video[0].play();
                $scope.hideControls = false;
                if (typeof(video[0].webkitEnterFullscreen) !== 'undefined') {
                    // This is for Android Stock.
                    video[0].webkitEnterFullscreen();
                } else if (typeof(video[0].webkitRequestFullscreen) !== 'undefined') {
                    // This is for Chrome.
                    video[0].webkitRequestFullscreen();
                } else if (typeof(video[0].mozRequestFullScreen) !== 'undefined') {
                    video[0].mozRequestFullScreen();
                }

                document.onfullscreenchange = function() {
                    video[0].pause();
                };

                document.onwebkitfullscreenchange = function() {
                    video[0].pause();
                };
            }
        };

        $scope.toggleVideo = function($event) {
            if (video[0].paused) {
                video.removeAttr('controls');
                video[0].play();
                $scope.hideControls = true;
            } else {
                video.attr('controls', 'controls');
                video[0].pause();
                $scope.hideControls = false;
            }
        };

        function init() {
            video.removeAttr('controls');

            if (isFirefox) {
                video.attr('controls', 'controls');
                $scope.hideArrow = true;
            }
        }
        init();
    }])
;

/* global angular, $ */
angular.module('ua5App.home')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.when('', '/');
        $urlRouterProvider.otherwise('/');
        $stateProvider.state('home', {
            url: '/?v',
            templateUrl: 'states/home/home.html',
            controller: 'HomeCtrl',
            controllerAs: 'ctrl',
            resolve: {
                data: ['home', function(home) {
                    return home.get().then(function(data) {
                        return data;
                    });
                }]
            }
        });
    }])
    .controller('HomeCtrl', ['data', '$scope', '$stateParams', function(data, $scope, $stateParams) {
        $scope.videos = data.videos;

        $(window).off('mousewheel DOMMouseScroll');
        $(window).off('resize');
    }])
;

/* global angular */
angular.module('ua5App.index')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('index', {
            url: '/index/?v',
            templateUrl: 'states/index/index.html',
            controller: 'indexCtrl',
            controllerAs: 'ctrl',
            resolve: {
                data: ['index', function(index) {
                    return index.get().then(function(data) {
                        return data;
                    });
                }]
            },
            meta: {
                title: 'Index | An Imaginative Offer',
                url: 'https://ucla.arts.edu/an-imaginative-offer/index'
            }
        });
    }])
    .controller('indexCtrl', ['data', '$scope', '$stateParams', '$location', function(data, $scope, $stateParams, $location) {
        var location = $stateParams.v;
        if (location && location !== '') {
            switch (location) {
                case 'an-imaginative-offer':
                    $scope.videos = data.videos[0];
                    break;
                case 'leaning-forward':
                    $scope.videos = data.videos[1];
                    break;
                case 'opening-new-futures':
                    $scope.videos = data.videos[2];
                    break;
                default:
                    $scope.videos = data.videos[0];
            }
        }
    }])
;

/* global angular, _, $ */
angular.module('ua5App.participant')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('participants.participant', {
            url: '/:slug',
            templateUrl: 'states/participant/participant.html',
            controller: 'participantCtrl',
            controllerAs: 'ctrl'
        });
    }])
    .controller('participantCtrl', ['data', '$scope', '$stateParams', '$state', 'ngMeta', function(data, $scope, $stateParams, $state, ngMeta) {
        $scope.participant = _.findWhere(data.participants, {slug: $stateParams.slug});
        $scope.$on('app:escape:pressed', function() {
            $state.go('participants');
        });
        ngMeta.setTitle($scope.participant.name + ' | An Imaginative Offer');
        ngMeta.setTag('url', 'https://ucla.arts.edu/an-imaginative-offer/participants/' + $scope.participant.slug);
        ngMeta.setTag('image', 'https://ucla.arts.edu/an-imaginative-offer/' + $scope.participant.image);
        ngMeta.setTag('description', $scope.participant.bio);

        $(window).off('mousewheel DOMMouseScroll');
        $(window).off('resize');
    }])
;

/* global angular, $ */
angular.module('ua5App.participants')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('participants', {
            url: '/participants',
            templateUrl: 'states/participants/participants.html',
            controller: 'participantsCtrl',
            controllerAs: 'ctrl',
            resolve: {
                data: ['participants', function(participants) {
                    return participants.get().then(function(data) {
                        return data;
                    });
                }]
            },
            meta: {
                title: 'Participants | An Imaginative Offer',
                url: 'https://ucla.arts.edu/an-imaginative-offer/participants'
            }
        });
    }])
    .controller('participantsCtrl', ['data', '$scope', function(data, $scope) {
        $scope.data = data;
        $scope.orderByLastName = function(particpant) {
            return particpant.name.split(' ').slice(-1).join(' ');
        };

        $(window).off('mousewheel DOMMouseScroll');
        $(window).off('resize');
    }])
;

angular.module('ua5Templates').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('components/header/header.html',
    "<header\n" +
    "    class=\"header\"\n" +
    "    ng-class=\"{'header--hidden': $root.playing && !$root.moving, 'header--open': open}\">\n" +
    "    <div class=\"header__inner\">\n" +
    "        <a\n" +
    "            href=\"http://www.arts.ucla.edu/\"\n" +
    "            class=\"header__logo\"\n" +
    "            target=\"_blank\">\n" +
    "            <span ng-include=\"'assets/img/ucla-arts-logo.svg'\"></span>\n" +
    "        </a>\n" +
    "        <a\n" +
    "            class=\"header__hamburger\"\n" +
    "            ng-click=\"toggleOpen()\">\n" +
    "            <span></span>\n" +
    "            <span></span>\n" +
    "            <span></span>\n" +
    "            <span></span>\n" +
    "        </a>\n" +
    "        <nav class=\"header__links\">\n" +
    "            <div class=\"header__links-wrap\">\n" +
    "                <div class=\"header__link\">\n" +
    "                    <a\n" +
    "                        ui-sref=\"home({v: 'an-imaginative-offer'})\"\n" +
    "                        ng-class=\"{'active': currentParam === 'an-imaginative-offer'}\">\n" +
    "                        An Imaginative Offer\n" +
    "                    </a>\n" +
    "                    <a\n" +
    "                        class=\"header__link--index\"\n" +
    "                        ui-sref=\"index({v: 'an-imaginative-offer'})\">\n" +
    "                        Index\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "                <div class=\"header__link\">\n" +
    "                    <a\n" +
    "                        ui-sref=\"home({v: 'leaning-forward'})\"\n" +
    "                        ng-class=\"{'active': currentParam === 'leaning-forward'}\">\n" +
    "                        Leaning Forward\n" +
    "                    </a>\n" +
    "                    <a\n" +
    "                        class=\"header__link--index\"\n" +
    "                        ui-sref=\"index({v: 'leaning-forward'})\">\n" +
    "                        Index\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "                <div class=\"header__link\">\n" +
    "                    <a\n" +
    "                        ui-sref=\"home({v: 'opening-new-futures'})\"\n" +
    "                        ng-class=\"{'active': currentParam === 'opening-new-futures'}\">\n" +
    "                        Opening New Futures\n" +
    "                    </a>\n" +
    "                    <a\n" +
    "                        class=\"header__link--index\"\n" +
    "                        ui-sref=\"index({v: 'opening-new-futures'})\">\n" +
    "                        Index\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "                <div class=\"header__link\">\n" +
    "                    <a\n" +
    "                        ui-sref=\"about\"\n" +
    "                        ui-sref-active=\"active\">\n" +
    "                        About\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "                <div class=\"header__link\">\n" +
    "                    <a\n" +
    "                        ui-sref=\"participants\"\n" +
    "                        ui-sref-active=\"active\">\n" +
    "                        Participants\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </nav>\n" +
    "    </div>\n" +
    "</header>\n"
  );


  $templateCache.put('components/index-carousel/index-carousel.html',
    "<div class=\"index-carousel-main\" ng-class=\"{'show': isLoaded}\">\n" +
    "    <div class=\"index-carousel-main__inner\">\n" +
    "        <div class=\"index-carousel__thumbs\">\n" +
    "            <div\n" +
    "                ng-repeat=\"thumb in videos\"\n" +
    "                ng-class=\"{'active': thumb === currentVideo}\"\n" +
    "                class=\"index-carousel__thumb\"\n" +
    "                title=\"{{ thumb.title }}\"\n" +
    "                ng-style=\"{'background-image': 'url(' + thumb.thumb + ')'}\"\n" +
    "                ng-click=\"updateCurrentVideo(thumb)\">\n" +
    "                <div class=\"index-carousel__timestamp\">{{ thumb.timestamp }}</div>\n" +
    "                <div class=\"index-carousel__meta-container\">\n" +
    "                    <div ng-if=\"thumb.name\" class=\"index-carousel__name\" ng-bind-html=\"thumb.name\"></div>\n" +
    "                    <div ng-if=\"thumb.title\" class=\"index-carousel__title\" ng-bind-html=\"thumb.title\"></div>\n" +
    "                    <div ng-if=\"thumb.artwork\" class=\"index-carousel__artwork\" ng-bind-html=\"thumb.artwork\"></div>\n" +
    "                    <div ng-if=\"thumb.year\" class=\"index-carousel__year\" ng-bind-html=\"thumb.year\"></div>\n" +
    "                    <div ng-if=\"thumb.medium\" class=\"index-carousel__medium\" ng-bind-html=\"thumb.medium\"></div>\n" +
    "                    <div ng-if=\"thumb.size\" class=\"index-carousel__size\" ng-bind-html=\"thumb.size\"></div>\n" +
    "                    <div class=\"index-carousel__links-container\">\n" +
    "                        <div\n" +
    "                            ng-repeat=\"link in thumb.links\"\n" +
    "                            class=\"index-carousel__link\">\n" +
    "                            <a\n" +
    "                                ng-if=\"link.url\"\n" +
    "                                href=\"{{link.url}}\"\n" +
    "                                target=\"_blank\">\n" +
    "                                {{link.cta}}\n" +
    "                            </a>\n" +
    "                            <a\n" +
    "                                ng-if=\"link.slug\"\n" +
    "                                ui-sref=\"participants.participant({slug: '{{link.slug}}'})\">\n" +
    "                                {{link.cta}}\n" +
    "                            </a>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"index-carousel-slider\" ng-class=\"{'show': isLoaded}\">\n" +
    "    <div class=\"index-carousel-slider__inner\">\n" +
    "        <div class=\"index-carousel-slider__viewport\">\n" +
    "        </div>\n" +
    "        <div class=\"index-carousel-slider__thumbs\" ng-click=\"jumpToPoint($event)\">\n" +
    "            <div\n" +
    "                ng-repeat=\"thumb in videos\"\n" +
    "                class=\"index-carousel-slider__thumb\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/vcarousel/vcarousel.html',
    "<div\n" +
    "    class=\"vcarousel\"\n" +
    "    ng-class=\"{'vcarousel--playing': $root.playing, 'vcarousel--moving': $root.moving}\"\n" +
    "    ng-mousemove=\"mouseMoving()\">\n" +
    "    <div class=\"vcarousel__desktop\">\n" +
    "        <div class=\"vcarousel__video-wrap\">\n" +
    "            <a\n" +
    "                href=\"\"\n" +
    "                class=\"vcarousel__cover\"\n" +
    "                ng-click=\"togglePlay()\">\n" +
    "                <h2 class=\"vcarousel__title\">\n" +
    "                    <span\n" +
    "                        class=\"vcarousel__title__icon\"\n" +
    "                        ng-include=\"'assets/img/play-btn.svg'\">\n" +
    "                    </span>\n" +
    "                    <span\n" +
    "                        class=\"vcarousel__title__text\"\n" +
    "                        ng-if=\"!currentVideo.titleImg.show\"\n" +
    "                        ng-bind=\"currentVideo.title\">\n" +
    "                    </span>\n" +
    "                    <div\n" +
    "                        class=\"vcarousel__title__img\"\n" +
    "                        ng-if=\"currentVideo.titleImg.show\"\n" +
    "                        ng-include=\"currentVideo.titleImg.asset\">\n" +
    "                    </div>\n" +
    "                </h2>\n" +
    "                <div\n" +
    "                    class=\"vcarousel__pause\"\n" +
    "                    ng-include=\"'assets/img/pause-btn.svg'\">\n" +
    "                </div>\n" +
    "            </a>\n" +
    "            <video\n" +
    "                class=\"vcarousel__video\"\n" +
    "                poster=\"{{ currentVideo.poster }}\"\n" +
    "                src=\"{{ source | trust}}\"\n" +
    "                type=\"video/mp4\">\n" +
    "            </video>\n" +
    "        </div>\n" +
    "        <div class=\"vcarousel__thumbs__scroll-container\">\n" +
    "            <div class=\"vcarousel__thumbs\">\n" +
    "                <a\n" +
    "                    ng-repeat=\"thumb in videos\"\n" +
    "                    ng-class=\"{'active': thumb === currentVideo}\"\n" +
    "                    class=\"vcarousel__thumb\"\n" +
    "                    title=\"{{ thumb.title }}\"\n" +
    "                    ng-style=\"{'background-image': 'url(' + thumb.thumb + ')'}\"\n" +
    "                    ng-click=\"updateCurrentVideo(thumb)\">\n" +
    "                    <span\n" +
    "                        class=\"vcarousel__thumb__caption\"\n" +
    "                        ng-bind-html=\"thumb.caption\">\n" +
    "                    </span>\n" +
    "                </a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"vcarousel__mobile\">\n" +
    "        <div\n" +
    "            class=\"vcarousel__mobile__item\"\n" +
    "            ng-repeat=\"video in videos\">\n" +
    "            <video\n" +
    "                controls\n" +
    "                class=\"vcarousel__mobile__video\"\n" +
    "                poster=\"{{ video.poster }}\"\n" +
    "                src=\"{{ video.videoMp4 | trust}}\"\n" +
    "                type=\"video/mp4\">\n" +
    "            </video>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('index.html',
    "<!DOCTYPE html>\n" +
    "<html\n" +
    "    class=\"no-js\"\n" +
    "    lang=\"en\"\n" +
    "    data-ng-app=\"ua5App\"\n" +
    "    ng-strict-di=\"true\"\n" +
    "    data-ng-cloak\n" +
    "    data-app>\n" +
    "    <head>\n" +
    "        <meta charset=\"utf-8\">\n" +
    "        <meta name=\"fragment\" content=\"!\">\n" +
    "        <base href=\"/\">\n" +
    "        <script src=\"bower_components/angular/angular.js\"></script>\n" +
    "        <link\n" +
    "            href=\"_build/app.css?v=1530900085\"\n" +
    "            rel=\"stylesheet\"\n" +
    "            type=\"text/css\">\n" +
    "        <meta\n" +
    "            name=\"viewport\"\n" +
    "            content=\"width=device-width, initial-scale=1.0, user-scalable=no\">\n" +
    "        <title ng-bind=\"ngMeta.title\">An Imaginative Offer | UCLA School of the Arts and Architecture</title>\n" +
    "        <meta content=\"An Imaginative Offer | UCLA School of the Arts and Architecture\">\n" +
    "        <meta\n" +
    "            name=\"description\"\n" +
    "            ng-content=\"{{ ngMeta.description }}\"\n" +
    "            content=\"Through the unique voices of the UCLA Arts community, An Imaginative Offer celebrates the essential role of the arts in society. We believe that the arts are fundamental to the cognitive, critical, inquisitive life of a public research university, and that the practice and presence of the arts are a cornerstone of the creative, innovative thinking and collaborative spirit that the 21st century demands.\">\n" +
    "        <meta\n" +
    "            property=\"og:description\"\n" +
    "            ng-content=\"{{ ngMeta.description }}\"\n" +
    "            content=\"Through the unique voices of the UCLA Arts community, An Imaginative Offer celebrates the essential role of the arts in society. We believe that the arts are fundamental to the cognitive, critical, inquisitive life of a public research university, and that the practice and presence of the arts are a cornerstone of the creative, innovative thinking and collaborative spirit that the 21st century demands.\">\n" +
    "        <meta\n" +
    "            property=\"og:image\"\n" +
    "            content=\"http://www.arts.ucla.edu/an-imaginative-offer/ucla-arts.jpg\">\n" +
    "        <meta\n" +
    "            property=\"og:site_name\"\n" +
    "            content=\"An Imaginative Offer\">\n" +
    "        <meta\n" +
    "            property=\"og:url\"\n" +
    "            content=\"http://www.arts.ucla.edu/an-imaginative-offer/\"\n" +
    "            ng-content=\"{{ ngMeta.url }}\">\n" +
    "        <meta\n" +
    "            property=\"og:type\"\n" +
    "            content=\"website\">\n" +
    "        <meta\n" +
    "            name=\"twitter:card\"\n" +
    "            content=\"summary_large_image\">\n" +
    "        <meta\n" +
    "            name=\"twitter:title\"\n" +
    "            content=\"An Imaginative Offer | UCLA School of the Arts and Architecture\">\n" +
    "        <meta\n" +
    "            property=\"twitter:image:src\"\n" +
    "            content=\"http://www.arts.ucla.edu/an-imaginative-offer/ucla-arts.jpg\">\n" +
    "        <link\n" +
    "            href=\"assets/img/favicon.png\"\n" +
    "            rel=\"icon\"\n" +
    "            type=\"image/png\">\n" +
    "        <script>\n" +
    "            //-- Google Analytics\n" +
    "            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n" +
    "            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n" +
    "            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n" +
    "            })(window,document,'script','//www.google-analytics.com/analytics.js','ga');\n" +
    "            ga('create', 'UA-1965480-1', 'auto');\n" +
    "            var _gaq = _gaq || [];\n" +
    "            _gaq.push(['_setDomainName', 'none']);\n" +
    "        </script>\n" +
    "    </head>\n" +
    "    <body ng-class=\"pageClass\">\n" +
    "        <noscript>\n" +
    "            <div class=\"noscript\">\n" +
    "                Please enable JavaScript on your browser or upgrade to <a href=\"http://www.google.com/chrome/\" target=\"_blank\">Google Chrome</a> to use Base Angular.\n" +
    "            </div>\n" +
    "        </noscript>\n" +
    "        <div header></div>\n" +
    "        <div\n" +
    "            ui-view\n" +
    "            class=\"fade\">\n" +
    "        </div>\n" +
    "        <!-- start bower_components -->\n" +
    "        <script src=\"bower_components/angulartics/dist/angulartics.min.js\"></script>\n" +
    "        <script src=\"bower_components/angulartics-google-analytics/dist/angulartics-google-analytics.min.js\"></script>\n" +
    "        <script src=\"bower_components/jquery/dist/jquery.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-resource/angular-resource.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-sanitize/angular-sanitize.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-touch/angular-touch.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-animate/angular-animate.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-ui-router/release/angular-ui-router.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-loading-bar/build/loading-bar.min.js\"></script>\n" +
    "        <script src=\"bower_components/gsap/src/minified/TweenMax.min.js\"></script>\n" +
    "        <script src=\"bower_components/gsap/src/minified/utils/Draggable.min.js\"></script>\n" +
    "        <script src=\"bower_components/imagesloaded/imagesloaded.pkgd.min.js\"></script>\n" +
    "        <script src=\"bower_components/underscore/underscore.js\"></script>\n" +
    "        <script src=\"bower_components/slick-carousel/slick/slick.min.js\"></script>\n" +
    "        <script src=\"bower_components/ngMeta/dist/ngMeta.min.js\"></script>\n" +
    "        <script src=\"bower_components/jquery-unorphanize/unorphanize.jquery.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-modal-service/dst/angular-modal-service.min.js\"></script>\n" +
    "        <script src=\"bower_components/modernizr/modernizr.js\"></script>\n" +
    "        <!-- end bower_components -->\n" +
    "        <script src=\"app.js\"></script>\n" +
    "        <!-- state scripts -->\n" +
    "        <script src=\"states/home/home.js\"></script>\n" +
    "        <script src=\"states/about/about.js\"></script>\n" +
    "        <script src=\"states/participants/participants.js\"></script>\n" +
    "        <script src=\"states/participant/participant.js\"></script>\n" +
    "        <script src=\"states/index/index.js\"></script>\n" +
    "        <!-- end state scripts -->\n" +
    "        <!-- component scripts -->\n" +
    "        <script src=\"components/header/header.js\"></script>\n" +
    "        <script src=\"components/unorphanize/unorphanize.js\"></script>\n" +
    "        <script src=\"components/scroll-reveal/scroll-reveal.js\"></script>\n" +
    "        <script src=\"components/share-fb/share-fb.js\"></script>\n" +
    "        <script src=\"components/share-tw/share-tw.js\"></script>\n" +
    "        <script src=\"components/share-e/share-e.js\"></script>\n" +
    "        <script src=\"components/vcarousel/vcarousel.js\"></script>\n" +
    "        <script src=\"components/index-carousel/index-carousel.js\"></script>\n" +
    "        <!-- end component scripts -->\n" +
    "        <!-- services scripts -->\n" +
    "        <script src=\"services/preloader.js\"></script>\n" +
    "        <script src=\"services/popup.js\"></script>\n" +
    "        <!-- end services scripts -->\n" +
    "        <!-- resources scripts -->\n" +
    "        <script src=\"resources/home.js\"></script>\n" +
    "        <script src=\"resources/about.js\"></script>\n" +
    "        <script src=\"resources/participants.js\"></script>\n" +
    "        <script src=\"resources/index.js\"></script>\n" +
    "        <!-- end resources scripts -->\n" +
    "        <!-- filters scripts -->\n" +
    "        <script src=\"filters/trust.js\"></script>\n" +
    "        <!-- end filters scripts -->\n" +
    "        <!-- animations scripts -->\n" +
    "        <script src=\"animations/fade.js\"></script>\n" +
    "        <script src=\"animations/fade-child.js\"></script>\n" +
    "        <!-- end animations scripts -->\n" +
    "    </body>\n" +
    "</html>\n"
  );


  $templateCache.put('index.unprocessed.html',
    "<!DOCTYPE html>\n" +
    "<html\n" +
    "    class=\"no-js\"\n" +
    "    lang=\"en\"\n" +
    "    data-ng-app=\"ua5App\"\n" +
    "    ng-strict-di=\"true\"\n" +
    "    data-ng-cloak\n" +
    "    data-app>\n" +
    "    <head>\n" +
    "        <meta charset=\"utf-8\">\n" +
    "        <meta name=\"fragment\" content=\"!\">\n" +
    "        <base href=\"/\">\n" +
    "        <!-- @if PRODUCTION='false' -->\n" +
    "        <script src=\"bower_components/angular/angular.js\"></script>\n" +
    "        <!-- @endif -->\n" +
    "        <!-- @if TESTING='true' -->\n" +
    "        <link\n" +
    "            href=\"_build/app.css?v=<!-- @echo VERSION -->\"\n" +
    "            rel=\"stylesheet\"\n" +
    "            type=\"text/css\">\n" +
    "        <!-- @endif -->\n" +
    "        <!-- @if TESTING='false' -->\n" +
    "        <link\n" +
    "            href=\"app.css?v=<!-- @echo VERSION -->\"\n" +
    "            rel=\"stylesheet\"\n" +
    "            type=\"text/css\">\n" +
    "        <!-- @endif -->\n" +
    "        <meta\n" +
    "            name=\"viewport\"\n" +
    "            content=\"width=device-width, initial-scale=1.0, user-scalable=no\">\n" +
    "        <title ng-bind=\"ngMeta.title\">An Imaginative Offer | UCLA School of the Arts and Architecture</title>\n" +
    "        <meta content=\"An Imaginative Offer | UCLA School of the Arts and Architecture\">\n" +
    "        <meta\n" +
    "            name=\"description\"\n" +
    "            ng-content=\"{{ ngMeta.description }}\"\n" +
    "            content=\"Through the unique voices of the UCLA Arts community, An Imaginative Offer celebrates the essential role of the arts in society. We believe that the arts are fundamental to the cognitive, critical, inquisitive life of a public research university, and that the practice and presence of the arts are a cornerstone of the creative, innovative thinking and collaborative spirit that the 21st century demands.\">\n" +
    "        <meta\n" +
    "            property=\"og:description\"\n" +
    "            ng-content=\"{{ ngMeta.description }}\"\n" +
    "            content=\"Through the unique voices of the UCLA Arts community, An Imaginative Offer celebrates the essential role of the arts in society. We believe that the arts are fundamental to the cognitive, critical, inquisitive life of a public research university, and that the practice and presence of the arts are a cornerstone of the creative, innovative thinking and collaborative spirit that the 21st century demands.\">\n" +
    "        <meta\n" +
    "            property=\"og:image\"\n" +
    "            content=\"http://www.arts.ucla.edu/an-imaginative-offer/ucla-arts.jpg\">\n" +
    "        <meta\n" +
    "            property=\"og:site_name\"\n" +
    "            content=\"An Imaginative Offer\">\n" +
    "        <meta\n" +
    "            property=\"og:url\"\n" +
    "            content=\"http://www.arts.ucla.edu/an-imaginative-offer/\"\n" +
    "            ng-content=\"{{ ngMeta.url }}\">\n" +
    "        <meta\n" +
    "            property=\"og:type\"\n" +
    "            content=\"website\">\n" +
    "        <meta\n" +
    "            name=\"twitter:card\"\n" +
    "            content=\"summary_large_image\">\n" +
    "        <meta\n" +
    "            name=\"twitter:title\"\n" +
    "            content=\"An Imaginative Offer | UCLA School of the Arts and Architecture\">\n" +
    "        <meta\n" +
    "            property=\"twitter:image:src\"\n" +
    "            content=\"http://www.arts.ucla.edu/an-imaginative-offer/ucla-arts.jpg\">\n" +
    "        <link\n" +
    "            href=\"assets/img/favicon.png\"\n" +
    "            rel=\"icon\"\n" +
    "            type=\"image/png\">\n" +
    "        <script>\n" +
    "            //-- Google Analytics\n" +
    "            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n" +
    "            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n" +
    "            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n" +
    "            })(window,document,'script','//www.google-analytics.com/analytics.js','ga');\n" +
    "            ga('create', 'UA-1965480-1', 'auto');\n" +
    "            var _gaq = _gaq || [];\n" +
    "            _gaq.push(['_setDomainName', 'none']);\n" +
    "        </script>\n" +
    "    </head>\n" +
    "    <body ng-class=\"pageClass\">\n" +
    "        <noscript>\n" +
    "            <div class=\"noscript\">\n" +
    "                Please enable JavaScript on your browser or upgrade to <a href=\"http://www.google.com/chrome/\" target=\"_blank\">Google Chrome</a> to use Base Angular.\n" +
    "            </div>\n" +
    "        </noscript>\n" +
    "        <div header></div>\n" +
    "        <div\n" +
    "            ui-view\n" +
    "            class=\"fade\">\n" +
    "        </div>\n" +
    "        <!-- @if PRODUCTION='true' -->\n" +
    "            <!-- @if TESTING='true' -->\n" +
    "            <script src=\"_build/vendor.js?v=<!-- @echo VERSION -->\"></script>\n" +
    "            <script src=\"_build/app.js?v=<!-- @echo VERSION -->\"></script>\n" +
    "            <!-- @endif -->\n" +
    "            <!-- @if TESTING='false' -->\n" +
    "            <script src=\"vendor.js?v=<!-- @echo VERSION -->\"></script>\n" +
    "            <script src=\"app.js?v=<!-- @echo VERSION -->\"></script>\n" +
    "            <!-- @endif -->\n" +
    "        <!-- @endif -->\n" +
    "        <!-- @if PRODUCTION='false' -->\n" +
    "        <!-- start bower_components -->\n" +
    "        <script src=\"bower_components/angulartics/dist/angulartics.min.js\"></script>\n" +
    "        <script src=\"bower_components/angulartics-google-analytics/dist/angulartics-google-analytics.min.js\"></script>\n" +
    "        <script src=\"bower_components/jquery/dist/jquery.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-resource/angular-resource.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-sanitize/angular-sanitize.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-touch/angular-touch.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-animate/angular-animate.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-ui-router/release/angular-ui-router.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-loading-bar/build/loading-bar.min.js\"></script>\n" +
    "        <script src=\"bower_components/gsap/src/minified/TweenMax.min.js\"></script>\n" +
    "        <script src=\"bower_components/gsap/src/minified/utils/Draggable.min.js\"></script>\n" +
    "        <script src=\"bower_components/imagesloaded/imagesloaded.pkgd.min.js\"></script>\n" +
    "        <script src=\"bower_components/underscore/underscore.js\"></script>\n" +
    "        <script src=\"bower_components/slick-carousel/slick/slick.min.js\"></script>\n" +
    "        <script src=\"bower_components/ngMeta/dist/ngMeta.min.js\"></script>\n" +
    "        <script src=\"bower_components/jquery-unorphanize/unorphanize.jquery.min.js\"></script>\n" +
    "        <script src=\"bower_components/angular-modal-service/dst/angular-modal-service.min.js\"></script>\n" +
    "        <script src=\"bower_components/modernizr/modernizr.js\"></script>\n" +
    "        <!-- end bower_components -->\n" +
    "        <script src=\"app.js\"></script>\n" +
    "        <!-- state scripts -->\n" +
    "        <script src=\"states/home/home.js\"></script>\n" +
    "        <script src=\"states/about/about.js\"></script>\n" +
    "        <script src=\"states/participants/participants.js\"></script>\n" +
    "        <script src=\"states/participant/participant.js\"></script>\n" +
    "        <script src=\"states/index/index.js\"></script>\n" +
    "        <!-- end state scripts -->\n" +
    "        <!-- component scripts -->\n" +
    "        <script src=\"components/header/header.js\"></script>\n" +
    "        <script src=\"components/unorphanize/unorphanize.js\"></script>\n" +
    "        <script src=\"components/scroll-reveal/scroll-reveal.js\"></script>\n" +
    "        <script src=\"components/share-fb/share-fb.js\"></script>\n" +
    "        <script src=\"components/share-tw/share-tw.js\"></script>\n" +
    "        <script src=\"components/share-e/share-e.js\"></script>\n" +
    "        <script src=\"components/vcarousel/vcarousel.js\"></script>\n" +
    "        <script src=\"components/index-carousel/index-carousel.js\"></script>\n" +
    "        <!-- end component scripts -->\n" +
    "        <!-- services scripts -->\n" +
    "        <script src=\"services/preloader.js\"></script>\n" +
    "        <script src=\"services/popup.js\"></script>\n" +
    "        <!-- end services scripts -->\n" +
    "        <!-- resources scripts -->\n" +
    "        <script src=\"resources/home.js\"></script>\n" +
    "        <script src=\"resources/about.js\"></script>\n" +
    "        <script src=\"resources/participants.js\"></script>\n" +
    "        <script src=\"resources/index.js\"></script>\n" +
    "        <!-- end resources scripts -->\n" +
    "        <!-- filters scripts -->\n" +
    "        <script src=\"filters/trust.js\"></script>\n" +
    "        <!-- end filters scripts -->\n" +
    "        <!-- animations scripts -->\n" +
    "        <script src=\"animations/fade.js\"></script>\n" +
    "        <script src=\"animations/fade-child.js\"></script>\n" +
    "        <!-- end animations scripts -->\n" +
    "        <!-- @endif -->\n" +
    "    </body>\n" +
    "</html>\n"
  );


  $templateCache.put('states/about/about.html',
    "<div class=\"about\">\n" +
    "   <div class=\"about__inner\">\n" +
    "       <div\n" +
    "           class=\"about__logo\"\n" +
    "           ng-include=\"'assets/img/an-imaginative-offer-logo.svg'\">\n" +
    "       </div>\n" +
    "       <div class=\"about__row\">\n" +
    "           <div class=\"about__col\">\n" +
    "               <div\n" +
    "                   class=\"about__description\"\n" +
    "                   ng-bind-html=\"data.description\"\n" +
    "                   unorphanize>\n" +
    "               </div>\n" +
    "               <div class=\"about__aside\">\n" +
    "                   <div\n" +
    "                       class=\"about__aside__list\">\n" +
    "                       <span ng-bind-html=\"data.credits\"></span>\n" +
    "                       <span ng-bind-html=\"data.specialThanks\"></span>\n" +
    "                   </div>\n" +
    "               </div>\n" +
    "               <!-- <div class=\"about__video\">\n" +
    "                   <div\n" +
    "                       ng-mouseover=\"hoverIn()\"\n" +
    "                       ng-mouseleave=\"hoverOut()\"\n" +
    "                       ng-click=\"toggleVideo()\"\n" +
    "                       ng-class=\"{'about__video__overlay--hidden': hideControls === true}\"\n" +
    "                       class=\"about__video__overlay\">\n" +
    "                       <span\n" +
    "                           ng-class=\"{'about__thumb__play--hide': hideControls === true || hideArrow === true}\"\n" +
    "                           class=\"about__thumb__play\"\n" +
    "                           ng-include=\"'assets/img/play-btn.svg'\">\n" +
    "                       </span>\n" +
    "                   </div>\n" +
    "                   <div\n" +
    "                       ng-click=\"playVideoMobile()\"\n" +
    "                       class=\"about__video__overlay--mobile\">\n" +
    "                       <span\n" +
    "                           class=\"about__thumb__play\"\n" +
    "                           ng-include=\"'assets/img/play-btn.svg'\">\n" +
    "                       </span>\n" +
    "                   </div>\n" +
    "                   <video\n" +
    "                       ng-click=\"toggleVideo()\"\n" +
    "                       ng-mouseover=\"hoverIn()\"\n" +
    "                       ng-mouseleave=\"hoverOut()\"\n" +
    "                       controls=\"true\"\n" +
    "                       class=\"about__video__video\"\n" +
    "                       src=\"{{source | trust}}\"\n" +
    "                       poster=\"{{ data.video.poster }}\"\n" +
    "                       type=\"{{type}}\">\n" +
    "                   </video>\n" +
    "               </div>\n" +
    "               <div\n" +
    "                   class=\"about__video__caption\"\n" +
    "                   ng-bind-html=\"data.video.caption\">\n" +
    "               </div>  -->\n" +
    "           </div>\n" +
    "       </div>\n" +
    "   </div>\n" +
    "</div>\n"
  );


  $templateCache.put('states/home/home.html',
    "<div class=\"home\">\n" +
    "    <div\n" +
    "        vcarousel\n" +
    "        vcarousel-videos=\"videos\">\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('states/index/index.html',
    "<div\n" +
    "    index-carousel\n" +
    "    index-videos=\"videos\"\n" +
    "    class=\"index\">\n" +
    "</div>\n"
  );


  $templateCache.put('states/participant/participant.html',
    "<div class=\"participant\">\n" +
    "    <div class=\"participant__inner\">\n" +
    "        <a\n" +
    "            class=\"participant__close\"\n" +
    "            ui-sref=\"participants\"\n" +
    "            ng-include=\"'assets/img/close-x.svg'\">\n" +
    "        </a>\n" +
    "    	<header class=\"participant__header\">\n" +
    "            <h1\n" +
    "                class=\"participant__name\"\n" +
    "                ng-bind=\"participant.name\">\n" +
    "            </h1>\n" +
    "            <div\n" +
    "                class=\"participant__department\"\n" +
    "                ng-if=\"participant.alumunus\"\n" +
    "                ng-bind=\"participant.alumunus\">\n" +
    "            </div>\n" +
    "            <div\n" +
    "                class=\"participant__department no-break\"\n" +
    "                ng-if=\"participant.department\"\n" +
    "                ng-bind-html=\"participant.department\">\n" +
    "            </div>\n" +
    "            <div\n" +
    "                class=\"participant__title\"\n" +
    "                ng-bind-html=\"participant.title\">\n" +
    "            </div>\n" +
    "        </header>\n" +
    "        <div class=\"participant__row\">\n" +
    "            <div class=\"participant__col\">\n" +
    "                <div\n" +
    "                    ng-class=\"{ 'participant__item__image-wrap--portrait': participant.portrait === true }\"\n" +
    "                    class=\"particpant__image-wrap\">\n" +
    "                    <img\n" +
    "                        class=\"participant__image\"\n" +
    "                        ng-src=\"{{ participant.imageLarge }}\">\n" +
    "                </div>\n" +
    "                <div\n" +
    "                    class=\"participant__video-cta\"\n" +
    "                    ng-if=\"participant.video\">\n" +
    "                    <a ui-sref=\"home({v: '{{participant.slug}}'})\">\n" +
    "                        <span\n" +
    "                            class=\"participant__video-cta__icon\"\n" +
    "                            ng-include=\"'assets/img/play-btn.svg'\">\n" +
    "                        </span>\n" +
    "                        <span>Watch video</span>\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"participant__col\">\n" +
    "                <div\n" +
    "                    class=\"participant__bio\"\n" +
    "                    ng-bind-html=\"participant.bio\">\n" +
    "                </div>\n" +
    "                <div class=\"participant__links\">\n" +
    "                    <ul>\n" +
    "                        <li ng-repeat=\"link in participant.hyperlinks\">\n" +
    "                            <a\n" +
    "                                href=\"{{ link }}\"\n" +
    "                                target=\"_blank\"\n" +
    "                                class=\"participant__link\">\n" +
    "                                {{ link }}\n" +
    "                            </a>\n" +
    "                        </li>\n" +
    "                    </ul>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('states/participants/participants.html',
    "<div class=\"participants\">\n" +
    "    <div class=\"participants__inner\">\n" +
    "    	<div class=\"participants__list\">\n" +
    "            <a\n" +
    "                href=\"\"\n" +
    "                ui-sref=\"participants.participant({slug: '{{participant.slug}}'})\"\n" +
    "                ng-repeat=\"participant in data.participants | orderBy : orderByLastName\"\n" +
    "                class=\"participants__item\">\n" +
    "                <div\n" +
    "                    ng-class=\"{ 'participants__item__image-wrap--portrait': participant.portrait === true }\"\n" +
    "                    class=\"participants__item__image-wrap\">\n" +
    "                    <img\n" +
    "                        class=\"participants__item__image\"\n" +
    "                        ng-src=\"{{ participant.image }}\">\n" +
    "                    <img\n" +
    "                        class=\"participants__item__transparency\"\n" +
    "                        ng-if=\"participant.portrait\"\n" +
    "                        ng-src=\"{{participant.transparency}}\">\n" +
    "                </div>\n" +
    "                <header class=\"participants__item__header\">\n" +
    "                    <h3\n" +
    "                        class=\"participants__item__name\"\n" +
    "                        ng-bind=\"participant.name\">\n" +
    "                    </h3>\n" +
    "                    <div\n" +
    "                        class=\"participants__item__department\"\n" +
    "                        ng-if=\"participant.alumunus\"\n" +
    "                        ng-bind=\"participant.alumunus\">\n" +
    "                    </div>\n" +
    "                    <div\n" +
    "                        class=\"participants__item__department\"\n" +
    "                        ng-if=\"participant.department\"\n" +
    "                        ng-bind-html=\"participant.department\">\n" +
    "                    </div>\n" +
    "                </header>\n" +
    "                <div\n" +
    "                    class=\"participants__item__title\"\n" +
    "                    ng-if=\"participant.title\"\n" +
    "                    ng-bind-html=\"participant.title\">\n" +
    "                </div>\n" +
    "                <div class=\"participants__item__cta\">\n" +
    "                    Read Bio\n" +
    "                </div>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div\n" +
    "        ui-view\n" +
    "        class=\"participants__overlay fade-child\">\n" +
    "    </div>\n" +
    "</div>\n"
  );

}]);

//# sourceMappingURL=app.js.map